import React, { useEffect } from "react";
import IMAGES from "../../constant/IMAGES";

const ModalFeature = ({
  cotent,
  onClose,
  isClose,
}: {
  cotent: any;
  onClose: () => void;
  isClose: boolean;
}) => {
  useEffect(() => {
    if (isClose) {
      document.body.classList.add("overflow-hidden"); // Chặn cuộn
    } else {
      document.body.classList.remove("overflow-hidden"); // Bỏ chặn
    }
    return () => {
      document.body.classList.remove("overflow-hidden"); // Cleanup khi unmount
    };
  }, [isClose]);

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-[rgba(0,0,0,0.77)] flex items-center justify-center z-[99] px-4"
    >
      <div
        className={`bg p-5 relative w-full max-w-[300px] sm:max-w-[700px] flex flex-col gap-1 border-feature before:rounded-none before:p-[1px] ${
          isClose ? "animate-updownModal" : "animate-downupModal"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={IMAGES.close}
          alt="close"
          onClick={onClose}
          className="absolute -top-2 -right-2 cursor-pointer"
        />
        <h1 className="text-[#F0D35A] text-sm sm:text-xl">{cotent.title}</h1>
        <p className="text-[#E3D4B7] text-sm sm:text-xl">{cotent.desc}</p>
      </div>
    </div>
  );
};

export default ModalFeature;
